import * as components from '../components'

export default [
  {
    path: '/',
    component: components.Admin,
    name: 'main',
    meta: { title: 'Main' },
    props: true
  },
  {
    path: '/account',
    component: components.Admin,
    name: 'accountManagement',
    meta: { title: 'Account Management' },
    props: true
  },
  {
    path: '/dietitian',
    component: components.Admin,
    name: 'dietitianManagement',
    meta: { title: 'Dietitians' },
    props: true
  },
  {
    path: '/file',
    component: components.Admin,
    name: 'fileManagement',
    meta: { title: 'Files' },
    props: true
  },
  {
    path: '/file/upload',
    component: components.Admin,
    name: 'uploadFile',
    meta: { title: 'Upload File' },
    props: true
  },
  {
    path: '/file/edit',
    component: components.Admin,
    name: 'editFile',
    meta: { title: 'Edit File' },
    props: true
  },
  {
    path: '/group',
    component: components.Admin,
    name: 'groupManagement',
    meta: { title: 'Groups' },
    props: true
  },
  {
    path: '/user',
    component: components.Admin,
    name: 'userManagement',
    meta: { title: 'Users' },
    props: true
  },
  {
    path: '/shared-content',
    component: components.Admin,
    name: 'sharedContent',
    meta: { title: 'Shared Content' },
    props: true
  },
  {
    path: '/user/add',
    component: components.Admin,
    name: 'addUser',
    meta: { title: 'Add User' },
    props: true
  },
  {
    path: '/user/parents',
    component: components.Admin,
    name: 'addParentGuardian',
    meta: { title: 'Add Parent / Guardian' },
    props: true
  },
  {
    path: '/user/payment',
    component: components.Admin,
    name: 'addPayment',
    meta: { title: 'Add Payment' },
    props: true
  },
  {
    path: '/login',
    component: components.Admin,
    name: 'login',
    props: true
  },
  {
    path: '/forgot-password',
    component: components.Admin,
    name: 'forgotPassword',
    meta: { title: 'Forgot Password' },
    props: true
  },
  {
    path: '/reset-password',
    component: components.Admin,
    name: 'resetPassword',
    meta: { title: 'Reset Password' },
    props: true
  },
  {
    path: '/signup',
    component: components.Admin,
    name: 'signup',
    meta: { title: 'Signup' },
    props: true
  },
  {
    path: '/verify',
    component: components.Admin,
    name: 'verify',
    meta: { title: 'Verify' },
    props: true
  },
  {
    path: '/resend-code',
    component: components.Admin,
    name: 'resend',
    meta: { title: 'Resend Code' },
    props: true
  },
  {
    path: '/who-are-you',
    component: components.Admin,
    name: 'whoAreYou',
    meta: { title: 'Who Are You' },
    props: true
  },
  {
    path: '/payment',
    component: components.Admin,
    name: 'payment',
    meta: { title: 'Payment' },
    props: true
  },
  {
    path: '/payment/confirmed',
    component: components.Admin,
    name: 'confirmed',
    meta: { title: 'Payment Confirmed' },
    props: true
  },
  {
    path: '/payment/failure',
    component: components.Admin,
    name: 'failure',
    meta: { title: 'Payment Failure' },
    props: true
  },
  {
    path: '/bulk',
    component: components.Admin,
    name: 'bulkUpload',
    meta: { title: 'Bulk Upload' },
    props: true
  },
  {
    path: '/bulk/review',
    component: components.Admin,
    name: 'bulkUploadReview',
    meta: { title: 'Bulk Upload Review' },
    props: true
  },
  {
    path: '/bulk/payment',
    component: components.Admin,
    name: 'bulkPayment',
    meta: { title: 'Bulk Payment' },
    props: true
  },
  {
    path: '/dietitian/clients',
    component: components.Admin,
    name: 'dietitianClients',
    meta: { title: 'Clients' },
    props: true
  },
  {
    path: '/user/account',
    component: components.Admin,
    name: 'userAccountManagement',
    meta: { title: 'User Account Management' },
    props: true
  },
  {
    path: '/group/add',
    component: components.Admin,
    name: 'createGroup',
    meta: { title: 'Create New Group' },
    props: true
  },
  {
    path: '/group/edit',
    component: components.Admin,
    name: 'editGroup',
    meta: { title: 'Edit Group' },
    props: true
  },
  {
    path: '/group/users',
    component: components.Admin,
    name: 'groupUsers',
    meta: { title: 'Group Users' },
    props: true
  },
  {
    path: '/messages',
    component: components.Admin,
    name: 'messages',
    meta: { title: 'Messaging' },
    props: true
  },
  {
    path: '/subscriptions',
    component: components.Admin,
    name: 'manageSuibscriptions',
    meta: { title: 'Manage Subscriptions' },
    props: true
  },
  {
    path: '/subscriptions/edit',
    component: components.Admin,
    name: 'editSubscriptions',
    meta: { title: 'Edit Subscription' },
    props: true
  },
  {
    path: '/unsubscribe',
    component: components.Admin,
    name: 'unsubscribe',
    props: true
  },
  {
    path: '/survey',
    component: components.Admin,
    name: 'survey',
    props: true
  },
  {
    path: '/biometrics',
    component: components.Admin,
    name: 'survey',
    props: true
  },
  {
    path: '/add-parent',
    component: components.Admin,
    name: 'addParent',
    meta: { title: 'Add Parent / Guardian' },
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/routes/index.js